import styled from "styled-components";
import PokerChips from "../../poker-chips/PokerChips";

export const Container = styled(PokerChips)`
  margin-right: 1.3rem;
`;
